<template>
  <div class="install-page">
    <div class="container page d-flex h-100">
      <div class="row w-100 align-items-center">
        <div class="col-md-6 offset-md-3 col-xs-12">
          <card title="Sensoreal Setup" sub-title="Create admin user">
            <p><small>Before proceeding make sure the config.js file has been properly configured</small></p>
            <form v-on:submit.prevent="createAdminUser(user);">
              <fieldset class="form-group form-group--sm">
                <label>Username</label>
                <input
                  class="form-control form-control-lg"
                  type="text"
                  v-model="user.username"
                  placeholder="admin"
                  required
                />
              </fieldset>
              <fieldset class="form-group form-group--sm">
                <label>Email</label>
                <input
                  class="form-control form-control-lg"
                  type="email"
                  v-model="user.email"
                  placeholder="name@domain.com"
                  required
                />
              </fieldset>
              <fieldset class="form-group form-group--sm">
                <label>password</label>
                <input
                  class="form-control form-control-lg"
                  type="password"
                  v-model="user.password"
                  placeholder="password"
                  required
                />
              </fieldset>
              <fieldset class="form-group mt-4">
                <button class="btn btn-primary">Begin</button>
              </fieldset>
            </form>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex"
import { CONFIG_ITEMS_CREATE, FETCH_USER_COUNT, USER_CREATE } from "@/store/actions.type"
import configJson from '@/common/config.json'

export default {
  data() {
    return {
      user: {
        email: '',
        isAdmin: true,
        password: '',
        username: '',
        access: [
          'users',
          'assets',
          'pages',
          'navigation',
          'live',
          'settings'
        ]
      }
    };
  },

  computed: {
    ...mapState({
      errors: state => state.auth.errors,
    })
  },

  methods: {
    createAdminUser(user) {
      this.$store
        .dispatch(USER_CREATE, user)
        .then(() => {
          this.$notify({
            message: 'New user created',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'success'
          });

          // dispatch default config
          // this.$store
          //   .dispatch(CONFIG_ITEMS_CREATE, configJson)
          //   .then(() => {
          //     this.$notify({
          //       message: 'Config Items created',
          //       horizontalAlign: 'center',
          //       verticalAlign: 'top',
          //       type: 'success'
          //     })
          //   .catch(err => {
          //     this.$notify({
          //       message: 'Error - ' + err,
          //       horizontalAlign: 'center',
          //       verticalAlign: 'top',
          //       type: 'danger'
          //     });
          //   })
          //   })

            this.$router.push({ name: "login" })
        })
        .catch(err => {
          this.$notify({
            message: 'Error - ' + err,
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger'
          });
        })
    }
  }
}
</script>
<style lang="scss" scoped>

.install-page {
  background-color: #eaeaea;
  background-image: url('https://picsum.photos/1920/1080');
  background-size: cover;
  height: 100vh;
}
</style>
